<template>
	<div class="home" @scroll="handleScroll">
		<Header :scrollTop="scrollTop"></Header>
		<div class="backImg">
			<div class="contents">
				<div class="content list1">
					<div class="row block1_2">
						<!-- <div class="lbTitle">高层声音：</div> -->
						<!-- <div>{{marqueeList}}</div> -->
						<vue-marquee
							style="height:23px;width:100%"
							:showProgress="false"
							v-if="marqueeList.length > 0"
						>
							<vue-marquee-slide
								v-for="(i, index) in marqueeList"
								:key="index"
							>
								<span class="crilce"></span>
								<a
									class="marqueeTitle"
									:href="
										'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
											(i ? i.docid : 0) +
											'&leafid=' +
											(i ? i.leafid : 0)
									"
									target="_blank"
									>{{ i.title }}</a
								>
							</vue-marquee-slide>
						</vue-marquee>
					</div>
					<div class="row block1_1">
						<!-- <a
							:href="
								'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
									(hightTitle ? hightTitle.docid : 0) +
									'&leafid=' +
									(hightTitle ? hightTitle.leafid : 0)
							"
							target="_blank"
						>
							{{ hightTitle.title }}
						</a> -->
						<!-- 固定双碳五周年 -->
						<a :href="'#/fiveth'" target="_blank">
							<img src="../../assets/fiveth/title.png" alt="" />
						</a>
					</div>

					<div class="row block1_3 flexRow">
						<div class="cloumChunk ">
							<!-- 每日推荐 -->
							<div class="rowChunk details1_1">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/dynamicInfo?id=19&name=动态资讯&uid=A60602"
										class="spanA"
										>每日推荐</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/dynamicInfo?id=19&name=动态资讯&uid=A60602"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div class="shuangtan_img_info_box">
									<img
										src="../../assets/homeContent/smbg2.png"
										alt=""
									/>
									<a
										class="shuangtan_img_info_item"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												(mrtj[0] ? mrtj[0].docid : 0) +
												'&leafid=' +
												(mrtj[0] ? mrtj[0].leafid : 0)
										"
										target="_blank"
									>
										<h5>
											{{ mrtj[0] ? mrtj[0].title : '' }}
										</h5>
										<p>
											{{ mrtj[0] ? mrtj[0].summary : '' }}
										</p>
									</a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-if="index != 0"
										v-for="(item, index) in mrtj"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
							<!-- 热点专题 -->
							<div class="rowChunk details1_2">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/hotColumn?id=231&name=热点专题&uid=7392"
										class="spanA"
										>热点专题</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/hotColumn?id=231&name=热点专题&uid=7392"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div
									class="shuangtan_img_info_box"
									v-for="(item, index) in rdzt"
									:key="index"
									@click="toRdzt(item)"
								>
									<img :src="item.fileId" alt="" />
									<div class="shuangtan_img_info_item">
										<h5>{{ item.chnName }}</h5>
										<p>{{ item.introduction }}</p>
									</div>
								</div>
							</div>
						</div>

						<div class="cloumChunk">
							<!-- <div class="rowChunk details1_3_title">3</div> -->
							<!-- 碳排放交易市场行情 -->
							<div class="rowChunk details1_3">
								<kLines />
							</div>
							<div class="rowChunk details1_4 flexRow">
								<doubleLins
									:echartsId="'linesdoubley_echarts1'"
									:echartsData="ou"
								/>
								<doubleLins
									:echartsId="'linesdoubley_echarts2'"
									:echartsData="us"
								/>
							</div>
						</div>
						<div class="cloumChunk">
							<!-- 政策规划 -->
							<div class="rowChunk details1_5">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 10px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/column?id=13&name=政策规划&uid=A602&showType=2"
										class="spanA"
										>政策规划</a
									>
									<i></i>
									<div class="shuangtan_l_tab_smbox">
										<a
											ref="fetchDataZCFG_1"
											@click="
												clicktabfn(
													'/column?id=13&name=政策规划&uid=A6020101&showType=2'
												)
											"
											@mouseover="
												fetchDataZCFG(
													'A6020101',
													1,
													'fetchDataZCFG_1'
												)
											"
											href="javascript:void(0);"
											>中央</a
										><span class="fetchDatashu">|</span>
										<a
											ref="fetchDataZCFG_2"
											@click="
												clicktabfn(
													'/column?id=13&name=政策规划&uid=A6020102&showType=1-1'
												)
											"
											@mouseover="
												fetchDataZCFG(
													'A6020102',
													2,
													'fetchDataZCFG_2'
												)
											"
											href="javascript:void(0);"
											>地方</a
										>
									</div>
									<a
										class="article_l_more"
										href="#/column?id=13&name=政策规划&uid=A602&showType=2"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-for="(item, index) in zcfg"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>

							<div class="rowChunk details1_6">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 10px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/column?id=13&name=政策规划&uid=A6020103&showType=2"
										class="spanA"
										>政策解读</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/column?id=13&name=政策规划&uid=A6020103&showType=2"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-for="(item, index) in zcjd"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content list2">
					<div class="row block2_1">
						<img src="../../assets/homeContent/news.png" alt="" />
					</div>
					<div class="row block2_3 flexRow ">
						<div class="cloumChunk flexRow">
							<div class="flexClounm flexUnset">
								<div
									class="asticle_l_title_item flexRow"
									style="margin-bottom: 41px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/dynamicInfo?id=19&name=动态资讯&uid=A606"
										class="spanH5"
										>领域动态</a
									>
									<i></i>
								</div>
								<!-- 领域动态 -->
								<div class="flexRow ">
									<div class="flexClounm ">
										<!-- 气候生态 -->
										<div class="rowChunk details2_1">
											<div class="block2_3_backgroud">
												<div class="block2_3_title">
													<a
														href="#/dynamicInfo?id=19&name=动态资讯&uid=A60628"
														class="spanA"
														>气候生态</a
													>
												</div>
												<div
													class="shuangtan_l_tab_smbox"
												>
													<a
														ref="fetchDataQHST_1"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6062801'
															)
														"
														@mouseover="
															fetchDataQHST(
																'A6062801',
																1,
																'fetchDataQHST_1'
															)
														"
														href="javascript:void(0);"
														>气候治理</a
													><span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataQHST_2"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6062802'
															)
														"
														@mouseover="
															fetchDataQHST(
																'A6062802',
																2,
																'fetchDataQHST_2'
															)
														"
														href="javascript:void(0);"
														>生态环保</a
													>
												</div>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/smbg4.jpg"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(qhst[0]
																? qhst[0].docid
																: 0) +
															'&leafid=' +
															(qhst[0]
																? qhst[0].leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															qhst[0]
																? qhst[0].title
																: ''
														}}
													</h5>
													<p>
														{{
															qhst[0]
																? qhst[0]
																		.summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item,
													index) in qhst"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
										<!-- 碳市场 -->
										<div class="rowChunk details2_2">
											<div class="block2_3_backgroud">
												<div class="block2_3_title">
													<a
														href="#/dynamicInfo?id=19&name=动态资讯&uid=A60633"
														class="spanA"
														>碳市场</a
													>
												</div>
												<div
													class="shuangtan_l_tab_smbox"
												>
													<a
														ref="fetchDataTSC_3"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063303'
															)
														"
														@mouseover="
															fetchDataTSC(
																'A6063303',
																3,
																'fetchDataTSC_3'
															)
														"
														href="javascript:void(0);"
														>碳交易</a
													>
													<span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTSC_1"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063301'
															)
														"
														@mouseover="
															fetchDataTSC(
																'A6063301',
																1,
																'fetchDataTSC_1'
															)
														"
														href="javascript:void(0);"
														>碳资产</a
													><span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTSC_2"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063302'
															)
														"
														@mouseover="
															fetchDataTSC(
																'A6063302',
																2,
																'fetchDataTSC_2'
															)
														"
														href="javascript:void(0);"
														>碳定价</a
													>
												</div>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/bazaar.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(tsc[0]
																? tsc[0].docid
																: 0) +
															'&leafid=' +
															(tsc[0]
																? tsc[0].leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															tsc[0]
																? tsc[0].title
																: ''
														}}
													</h5>
													<p>
														{{
															tsc[0]
																? tsc[0].summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item, index) in tsc"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
									</div>
									<div class="flexClounm">
										<!-- 碳排放 -->
										<div class="rowChunk details2_3">
											<div class="block2_3_backgroud">
												<div class="block2_3_title">
													<a
														href="#/dynamicInfo?id=19&name=动态资讯&uid=A60632"
														class="spanA"
														>碳排放</a
													>
												</div>
												<div
													class="shuangtan_l_tab_smbox"
												>
													<a
														ref="fetchDataTPF_2"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063202'
															)
														"
														@mouseover="
															fetchDataTPF(
																'A6063202',
																2,
																'fetchDataTPF_2'
															)
														"
														href="javascript:void(0);"
														>能源利用</a
													>
													<span class="fetchDatashu"
														>|</span
													>

													<a
														ref="fetchDataTPF_3"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063203'
															)
														"
														@mouseover="
															fetchDataTPF(
																'A6063203',
																3,
																'fetchDataTPF_3'
															)
														"
														href="javascript:void(0);"
														>节能增效</a
													>
													<span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTPF_1"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063201'
															)
														"
														@mouseover="
															fetchDataTPF(
																'A6063201',
																1,
																'fetchDataTPF_1'
															)
														"
														href="javascript:void(0);"
														>低碳技术</a
													><span class="fetchDatashu"
														>|</span
													>

													<a
														ref="fetchDataTPF_4"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063204'
															)
														"
														@mouseover="
															fetchDataTPF(
																'A6063204',
																4,
																'fetchDataTPF_4'
															)
														"
														href="javascript:void(0);"
														>重点项目</a
													>
												</div>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/smbg1.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(tpf[0]
																? tpf[0].docid
																: 0) +
															'&leafid=' +
															(tpf[0]
																? tpf[0].leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															tpf[0]
																? tpf[0].title
																: ''
														}}
													</h5>
													<p>
														{{
															tpf[0]
																? tpf[0].summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item, index) in tpf"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
										<!-- 碳金融 -->
										<div class="rowChunk details2_4">
											<div class="block2_3_backgroud">
												<div class="block2_3_title">
													<a
														href="#/dynamicInfo?id=19&name=动态资讯&uid=A60634"
														class="spanA"
														>碳金融</a
													>
												</div>

												<div
													class="shuangtan_l_tab_smbox"
													style="margin-left: 20px;"
												>
													<a
														ref="fetchDataTJR_1"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063401'
															)
														"
														@mouseover="
															fetchDataTJR(
																'A6063401',
																1,
																'fetchDataTJR_1'
															)
														"
														href="javascript:void(0);"
														>碳信贷</a
													>
													<span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTJR_2"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063402'
															)
														"
														@mouseover="
															fetchDataTJR(
																'A6063402',
																2,
																'fetchDataTJR_2'
															)
														"
														href="javascript:void(0);"
														>碳基金</a
													>
													<span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTJR_3"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063403'
															)
														"
														@mouseover="
															fetchDataTJR(
																'A6063403',
																3,
																'fetchDataTJR_3'
															)
														"
														href="javascript:void(0);"
														>碳债券</a
													>
													<span class="fetchDatashu"
														>|</span
													>
													<a
														ref="fetchDataTJR_4"
														@click="
															clicktabfn(
																'/dynamicInfo?id=19&name=动态资讯&uid=A6063404'
															)
														"
														@mouseover="
															fetchDataTJR(
																'A6063404',
																4,
																'fetchDataTJR_4'
															)
														"
														href="javascript:void(0);"
														>碳衍生</a
													>
													<!-- <a @mouseover="fetchDataTJR('411304', 5)" href="javascript:void(0);"> 其他</a> -->
												</div>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/smbg5.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(tjr[0]
																? tjr[0].docid
																: 0) +
															'&leafid=' +
															(tjr[0]
																? tjr[0].leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															tjr[0]
																? tjr[0].title
																: ''
														}}
													</h5>
													<p>
														{{
															tjr[0]
																? tjr[0].summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item, index) in tjr"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="cloumChunk">
							<div
								class="asticle_l_title_item flexRow"
								style="margin-bottom: 35px;"
							>
								<img
									src="../../assets/homeContent/title_icon.jpg"
									alt=""
								/>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=country&tagName=中国"
									class="spanH5"
									>区域动态</a
								>
								<i></i>
							</div>
							<!-- 区域动态 -->
							<!-- 国际 -->
							<div class="rowChunk details2_5">
								<div class="flexClounm">
									<div>
										<img
											src="../../assets/homeContent/countryRadio.png"
											alt=""
										/>
									</div>
									<div class="countryLists">
										<div
											class="countryBlocks"
											v-for="(item, index) in countryList"
											:key="index"
											@click="
												clicktabfn(
													`/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=${item.type}&tagName=${item.name}`,
													true
												)
											"
										>
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
							<!-- 国内 -->
							<div class="rowChunk details2_6">
								<div class="flexClounm">
									<div>
										<img
											src="../../assets/homeContent/chinaRadio.png"
											alt=""
										/>
									</div>
									<div class="countryLists">
										<div
											class="countryBlocks"
											v-for="(item,
											index) in provinceList"
											v-if="item.name !== '不限'"
											@click="
												clicktabfn(
													`/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=${item.type}&tagName=${item.name}`,
													true
												)
											"
											:key="index"
										>
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row block2_4">
						<!-- 行业动态 -->

						<div class="block2_4_backgroud">
							<div class="block2_4_title">
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606"
									class="spanH5"
									>行业动态</a
								>
							</div>
						</div>
						<div class="block2_4_report_under_box">
							<div class="flexRow">
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=电力行业"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon1.png"
										alt=""
									/>
									<span>电力行业</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=能源行业"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon2.png"
										alt=""
									/>
									<span>能源行业</span>
								</a>

								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=钢铁行业"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon3.png"
										alt=""
									/>
									<span>钢铁行业</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=有色金属"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon4.png"
										alt=""
									/>
									<span>有色金属</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=石化化工"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon5.png"
										alt=""
									/>
									<span>石化化工</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=建筑行业"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon6.png"
										alt=""
									/>
									<span>建筑行业</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=交通运输"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon7.png"
										alt=""
									/>
									<span>交通运输</span>
								</a>
							</div>
							<div class="flexRow">
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=新能源"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon8.png"
										alt=""
									/>
									<span>新能源</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=新材料"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon9.png"
										alt=""
									/>
									<span>新材料</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=高端装备"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon10.png"
										alt=""
									/>
									<span>高端装备</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=生物技术"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon11.png"
										alt=""
									/>
									<span>生物技术</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=绿色环保"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon12.png"
										alt=""
									/>
									<span>绿色环保</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=新能源汽车"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon13.png"
										alt=""
									/>
									<span>新能源汽车</span>
								</a>
								<a
									href="#/dynamicInfo?id=19&name=动态资讯&uid=A606&tagType=industry&tagName=新一代信息技术"
									target="_blank"
								>
									<img
										src="../../assets/homeContent/icon14.png"
										alt=""
									/>
									<span style="text-align: center;width: 47%;"
										>新一代信息技术</span
									>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="content list3">
					<div class="row block3_1">
						<img src="../../assets/homeContent/report.png" alt="" />
					</div>
					<div class="row block3_2 flexRow">
						<div class="cloumChunk ">
							<!-- 专家评论 -->
							<div class="rowChunk details3_1">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/column?id=87&name=专家评论&uid=A610&showType=2"
										class="spanA"
										>专家评论</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/column?id=87&name=专家评论&uid=A610&showType=2"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div class="shuangtan_img_info_box">
									<img
										src="../../assets/homeContent/zjpl.png"
										alt=""
									/>
									<a
										class="shuangtan_img_info_item"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												(zjpl[0] ? zjpl[0].docid : 0) +
												'&leafid=' +
												(zjpl[0] ? zjpl[0].leafid : 0)
										"
										target="_blank"
									>
										<h5>
											{{ zjpl[0] ? zjpl[0].title : '' }}
										</h5>
										<p>
											{{ zjpl[0] ? zjpl[0].summary : '' }}
										</p>
									</a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-if="index != 0"
										v-for="(item, index) in zjpl"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
						</div>
						<!-- 学术论文 -->
						<div class="cloumChunk">
							<div class="rowChunk details3_3_title">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/paper?id=6&name=学术论文&uid=A617"
										class="spanA"
										>学术论文</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/paper?id=6&name=学术论文&uid=A617"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
							</div>
							<!-- 重点学科 -->
							<div class="rowChunk details3_3">
								<treemap :echartsData="''" />
							</div>
							<!-- 行业领域 -->
							<div class="rowChunk details3_4">
								<!-- <wordcounts /> -->
								<img
									src="../../assets/homeContent/postisonLink.png"
									alt=""
								/>
								<div class="postionLinks links1">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=低碳经济"
										target="_blank"
										>低碳经济</a
									>
								</div>
								<div class="postionLinks links2">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=能源经济"
										target="_blank"
										>能源经济</a
									>
								</div>
								<div class="postionLinks links3">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=碳排放"
										target="_blank"
										>碳排放</a
									>
								</div>
								<div class="postionLinks links4">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=碳金融"
										target="_blank"
										>碳金融</a
									>
								</div>
								<div class="postionLinks links5">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=低碳技术"
										target="_blank"
										>低碳技术</a
									>
								</div>
								<div class="postionLinks links6">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617&paperType=ESG"
										target="_blank"
										>ESG</a
									>
								</div>
								<div class="postionLinks links7">
									<a
										href="#/paper?id=6&name=学术论文&uid=A617"
										target="_blank"
										>学术热点</a
									>
								</div>
							</div>
						</div>
						<div class="cloumChunk">
							<!-- 研究报告 -->
							<div class="rowChunk details3_5">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 15px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/column?id=245&name=研究报告&uid=A618&showType=2"
										class="spanA"
										>研究报告</a
									>
									<i></i>
									<div class="shuangtan_l_tab_smbox">
										<a
											ref="fetchDataYJBG_1"
											@click="
												clicktabfn(
													'/column?id=245&name=研究报告&uid=A61831&showType=2'
												)
											"
											@mouseover="
												fetchDataYJBG(
													'A61831',
													1,
													'fetchDataYJBG_1'
												)
											"
											href="javascript:void(0);"
											>行业周评</a
										><span class="fetchDatashu">|</span>
										<a
											ref="fetchDataYJBG_2"
											@click="
												clicktabfn(
													'/column?id=245&name=研究报告&uid=A61801&showType=2'
												)
											"
											@mouseover="
												fetchDataYJBG(
													'A61801',
													2,
													'fetchDataYJBG_2'
												)
											"
											href="javascript:void(0);"
											>热点研究</a
										><span class="fetchDatashu">|</span>
										<a
											ref="fetchDataYJBG_3"
											@click="
												clicktabfn(
													'/column?id=245&name=研究报告&uid=A61802&showType=2'
												)
											"
											@mouseover="
												fetchDataYJBG(
													'A61802',
													3,
													'fetchDataYJBG_3'
												)
											"
											href="javascript:void(0);"
											>智库报告</a
										>
									</div>
									<a
										class="article_l_more"
										href="#/column?id=245&name=研究报告&uid=A618&showType=2"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div class="article_l_list">
									<a
										v-for="(item, index) in yjbg"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										class="flexRow reportList"
										target="_blank"
									>
										<img
											:src="
												require('../../assets/homeContent/reportImage/' +
													yjbg_uid +
													'_' +
													(index + 1) +
													'.png')
											"
											alt=""
											class="reportImg"
										/>
										<div class="reportSpanBlock">
											<p class="reportspan1">
												{{ item.title }}
											</p>
											<span class="reportspan2">{{
												item.deliveddate | subData
											}}</span>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content list4">
					<div class="row block4_1">
						<img
							src="../../assets/homeContent/practice.png"
							alt=""
						/>
					</div>
					<div class="row block4_3 flexRow ">
						<div class="cloumChunk flexRow">
							<div class="flexClounm flexUnset">
								<div
									class="asticle_l_title_item flexRow"
									style="margin-bottom: 41px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/actionPlan?id=9&name=实施方案&uid=1"
										class="spanH5"
										>实施方案</a
									>
									<i></i>
									<div class="shuangtan_l_tab_smbox">
										<a
											ref="fetchDataSTSJ_1"
											@click="
												clicktabfn(
													'/actionPlan?id=9&name=实施方案&uid=6'
												)
											"
											@mouseover="
												fetchDataSTSJ(
													'1',
													1,
													'fetchDataSTSJ_1'
												)
											"
											href="javascript:void(0);"
											>北京</a
										><span class="fetchDatashu">|</span>
										<a
											ref="fetchDataSTSJ_2"
											@click="
												clicktabfn(
													'/actionPlan?id=9&name=实施方案&uid=9'
												)
											"
											@mouseover="
												fetchDataSTSJ(
													'2',
													2,
													'fetchDataSTSJ_2'
												)
											"
											href="javascript:void(0);"
											>上海</a
										><span class="fetchDatashu">|</span>
										<a
											ref="fetchDataSTSJ_3"
											@click="
												clicktabfn(
													'/actionPlan?id=9&name=实施方案&uid=7'
												)
											"
											@mouseover="
												fetchDataSTSJ(
													'3',
													3,
													'fetchDataSTSJ_3'
												)
											"
											href="javascript:void(0);"
											>天津</a
										><span class="fetchDatashu">|</span
										><a
											ref="fetchDataSTSJ_4"
											@click="
												clicktabfn(
													'/actionPlan?id=9&name=实施方案&uid=27'
												)
											"
											@mouseover="
												fetchDataSTSJ(
													'4',
													4,
													'fetchDataSTSJ_4'
												)
											"
											href="javascript:void(0);"
											>重庆</a
										>
									</div>
									<a
										class="article_l_more"
										href="#/actionPlan?id=9&name=实施方案&uid=1"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<!-- 双碳实践 -->
								<div class="flexRow ">
									<div class="flexClounm ">
										<!-- 太阳能、风电总装机容量目标 -->
										<div class="rowChunk details4_1">
											<acrossBar
												echartsId="
													acrossBar_echarts_1
												"
												:echartsData="acrossBarDatas[0]"
											/>
										</div>
										<!-- 可再生能源消费比重目标 -->
										<div class="rowChunk details4_2">
											<acrossBar
												echartsId="
													acrossBar_echarts_2
												"
												:echartsData="acrossBarDatas[1]"
											/>
										</div>
									</div>
									<div class="flexClounm">
										<!-- 中心城区绿色出行比例目标 -->
										<div class="rowChunk details4_3">
											<acrossBar
												echartsId="
													acrossBar_echarts_3
												"
												:echartsData="acrossBarDatas[2]"
											/>
										</div>
										<!-- 生活垃圾资源化利用率目标 -->
										<div class="rowChunk details4_4">
											<acrossBar
												echartsId="
													acrossBar_echarts_4
												"
												:echartsData="acrossBarDatas[3]"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="cloumChunk">
							<!-- 典型案例 -->
							<div class="rowChunk details4_5">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 29px;"
								>
									<img
										src="../../assets/homeContent/title_icon.jpg"
										alt=""
									/>
									<a
										href="#/column?id=8&name=典型案例&uid=A619&showType=2"
										class="spanA"
										>典型案例</a
									>
									<i></i>
									<a
										class="article_l_more"
										href="#/column?id=8&name=典型案例&uid=A619&showType=2"
										target="_blank"
										>更多<img
											src="../../assets/homeContent/more.png"
											alt=""
									/></a>
								</div>
								<div class="shuangtan_img_info_box">
									<img
										src="../../assets/homeContent/case.png"
										alt=""
									/>
									<a
										class="shuangtan_img_info_item"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												(dxal[0] ? dxal[0].docid : 0) +
												'&leafid=' +
												(dxal[0] ? dxal[0].leafid : 0)
										"
										target="_blank"
									>
										<h5>
											{{ dxal[0] ? dxal[0].title : '' }}
										</h5>
										<p>
											{{ dxal[0] ? dxal[0].summary : '' }}
										</p>
									</a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-if="index != 0"
										v-for="(item, index) in dxal"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content list5">
					<div class="row block5_3 flexRow ">
						<div class="cloumChunk flexRow">
							<div class="flexClounm flexUnset">
								<div
									class="row block5_1"
									style="margin-bottom: 18px;"
								>
									<img
										src="../../assets/homeContent/greengold.png"
										alt=""
									/>
								</div>
								<!-- 绿金专题 -->
								<div class="flexRow ">
									<div class="flexClounm ">
										<!-- 政策规划  |  前沿动态 -->
										<div class="rowChunk details5_1">
											<div
												class="asticle_l_title_item littleTitle flexRow"
												style="margin-bottom: 20px;"
											>
												<a
													ref="fetchZCFGAndQYDT_1"
													@click="
														clicktabfn(
															'/column?id=47&name=特色专题&uid=A621011708&showType=2'
														)
													"
													@mouseover="
														fetchZCFGAndQYDT(
															'A621011708',
															1,
															'fetchZCFGAndQYDT_1'
														)
													"
													href="javascript:void(0);"
													class="spanC"
													>政策法规</a
												>
												<span class="fetchDatashu"
													>|</span
												>
												<a
													ref="fetchZCFGAndQYDT_2"
													@click="
														clicktabfn(
															'/column?id=47&name=特色专题&uid=A621011709&showType=2'
														)
													"
													@mouseover="
														fetchZCFGAndQYDT(
															'A621011709',
															2,
															'fetchZCFGAndQYDT_2'
														)
													"
													href="javascript:void(0);"
													class="spanC"
													>前沿动态</a
												>
												<i></i>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/dynamic.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(zcfgandqydt[0]
																? zcfgandqydt[0]
																		.docid
																: 0) +
															'&leafid=' +
															(zcfgandqydt[0]
																? zcfgandqydt[0]
																		.leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															zcfgandqydt[0]
																? zcfgandqydt[0]
																		.title
																: ''
														}}
													</h5>
													<p>
														{{
															zcfgandqydt[0]
																? zcfgandqydt[0]
																		.summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item,
													index) in zcfgandqydt"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
										<!-- 专家评论  |  案例实践-->
										<div class="rowChunk details5_2">
											<div
												class="asticle_l_title_item littleTitle flexRow"
												style="margin-bottom: 20px;"
											>
												<a
													ref="fetchZJPLAndALSJ_1"
													@click="
														clicktabfn(
															'/column?id=47&name=特色专题&uid=A621011702&showType=2'
														)
													"
													@mouseover="
														fetchZJPLAndALSJ(
															'A621011702',
															1,
															'fetchZJPLAndALSJ_1'
														)
													"
													href="javascript:void(0);"
													class="spanC"
													>专家评论</a
												>
												<span class="fetchDatashu"
													>|</span
												>
												<a
													ref="fetchZJPLAndALSJ_2"
													@click="
														clicktabfn(
															'/column?id=47&name=特色专题&uid=A621011710&showType=2'
														)
													"
													@mouseover="
														fetchZJPLAndALSJ(
															'A621011710',
															2,
															'fetchZJPLAndALSJ_2'
														)
													"
													href="javascript:void(0);"
													class="spanC"
													>案例实践</a
												>
												<i></i>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/case2.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(zjplandalsj[0]
																? zjplandalsj[0]
																		.docid
																: 0) +
															'&leafid=' +
															(zjplandalsj[0]
																? zjplandalsj[0]
																		.leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															zjplandalsj[0]
																? zjplandalsj[0]
																		.title
																: ''
														}}
													</h5>
													<p>
														{{
															zjplandalsj[0]
																? zjplandalsj[0]
																		.summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item,
													index) in zjplandalsj"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
									</div>
									<div class="flexClounm">
										<!-- 试验区 -->
										<div class="rowChunk details5_3">
											<div
												class="asticle_l_title_item littleTitle flexRow"
												style="margin-bottom: 20px;height: 27px;"
											>
												<a
													@click="
														clicktabfn(
															'/column?id=47&name=特色专题&uid=A6210119&showType=2'
														)
													"
													href="javascript:void(0);"
													class="spanA"
													>试验区</a
												>

												<i></i>
											</div>
											<div class="shuangtan_img_info_box">
												<img
													src="../../assets/homeContent/test.png"
													alt=""
												/>
												<a
													class="shuangtan_img_info_item"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															(syq[0]
																? syq[0].docid
																: 0) +
															'&leafid=' +
															(syq[0]
																? syq[0].leafid
																: 0)
													"
													target="_blank"
												>
													<h5>
														{{
															syq[0]
																? syq[0].title
																: ''
														}}
													</h5>
													<p>
														{{
															syq[0]
																? syq[0].summary
																: ''
														}}
													</p>
												</a>
											</div>
											<div
												class="article_l_list"
												style="margin-top: 8px;"
											>
												<a
													v-if="index != 0"
													v-for="(item, index) in syq"
													:key="index"
													:href="
														'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
															item.docid +
															'&leafid=' +
															item.leafid
													"
													target="_blank"
												>
													<span class="span1"
														>·
														{{ item.title }}</span
													>
													<span class="span2">{{
														item.deliveddate
															| subData
													}}</span>
												</a>
											</div>
										</div>
										<!-- 金融机构 -->
										<div class="rowChunk details5_4">
											<div
												class="asticle_l_title_item littleTitle flexRow"
												style="margin-bottom: 25px;"
											>
												<a
													href="#/column?id=47&name=特色专题&uid=A6210120&showType=2"
													class="spanA"
													>金融机构</a
												>
												<i></i>
											</div>
											<div class="lvjin_a_box">
												<a href="javascript:void(0);">
													<router-link
														target="_blank"
														:to="{
															path:
																'/column?id=47&name=特色专题&uid=A621012001&showType=2',
														}"
														style="border: 0;"
													>
														<img
															src="../../assets/homeContent/aicon1.png"
															alt=""
														/>
														<span>银行</span>
													</router-link>
												</a>
												<a href="javascript:void(0);">
													<router-link
														target="_blank"
														:to="{
															path:
																'/column?id=47&name=特色专题&uid=A621012002&showType=2',
														}"
														style="border: 0;"
													>
														<img
															src="../../assets/homeContent/aicon2.png"
															alt=""
														/>
														<span>券商</span>
													</router-link>
												</a>
												<a href="javascript:void(0);">
													<router-link
														target="_blank"
														:to="{
															path:
																'/column?id=47&name=特色专题&uid=A621012003&showType=2',
														}"
														style="border: 0;"
													>
														<img
															src="../../assets/homeContent/aicon3.png"
															alt=""
														/>
														<span>保险</span>
													</router-link>
												</a>
												<a href="javascript:void(0);">
													<router-link
														target="_blank"
														:to="{
															path:
																'/column?id=47&name=特色专题&uid=A621012004&showType=2',
														}"
														style="border: 0;"
													>
														<img
															src="../../assets/homeContent/aicon4.png"
															alt=""
														/>
														<span>基金</span>
													</router-link>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="cloumChunk">
							<!-- ESG专题 -->
							<div
								class="row block5_1"
								style="margin-bottom: 18px;"
							>
								<img
									src="../../assets/homeContent/esg.png"
									alt=""
								/>
							</div>
							<!-- 行业标准 -->
							<div class="rowChunk details5_5">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;height: 27px;"
								>
									<a
										@click="
											clicktabfn(
												'/column?id=47&name=特色专题&uid=A6212901&showType=2'
											)
										"
										href="javascript:void(0);"
										class="spanA"
										>前沿动态</a
									>

									<i></i>
								</div>
								<div class="shuangtan_img_info_box">
									<img
										src="../../assets/homeContent/industry.png"
										alt=""
									/>
									<a
										class="shuangtan_img_info_item"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												(hybz[0] ? hybz[0].docid : 0) +
												'&leafid=' +
												(hybz[0] ? hybz[0].leafid : 0)
										"
										target="_blank"
									>
										<h5>
											{{ hybz[0] ? hybz[0].title : '' }}
										</h5>
										<p>
											{{ hybz[0] ? hybz[0].summary : '' }}
										</p>
									</a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-if="index != 0"
										v-for="(item, index) in hybz"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
							<!-- 信息披露 -->
							<div class="rowChunk details5_6">
								<div
									class="asticle_l_title_item littleTitle flexRow"
									style="margin-bottom: 20px;height: 27px;"
								>
									<a
										@click="
											clicktabfn(
												'/column?id=47&name=特色专题&uid=A6212902&showType=2'
											)
										"
										href="javascript:void(0);"
										class="spanA"
										>信息披露</a
									>

									<i></i>
								</div>
								<div class="shuangtan_img_info_box">
									<img
										src="../../assets/homeContent/message.png"
										alt=""
									/>
									<a
										class="shuangtan_img_info_item"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												(xxpl[0] ? xxpl[0].docid : 0) +
												'&leafid=' +
												(xxpl[0] ? xxpl[0].leafid : 0)
										"
										target="_blank"
									>
										<h5>
											{{ xxpl[0] ? xxpl[0].title : '' }}
										</h5>
										<p>
											{{ xxpl[0] ? xxpl[0].summary : '' }}
										</p>
									</a>
								</div>
								<div
									class="article_l_list"
									style="margin-top: 8px;"
								>
									<a
										v-if="index != 0"
										v-for="(item, index) in xxpl"
										:key="index"
										:href="
											'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
												item.docid +
												'&leafid=' +
												item.leafid
										"
										target="_blank"
									>
										<span class="span1"
											>· {{ item.title }}</span
										>
										<span class="span2">{{
											item.deliveddate | subData
										}}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content list6">
					<!-- 相关链接 -->
					<img
						class="lianjie_main_title"
						src="../../assets/homeContent/correlation.png"
						alt=""
					/>
					<div class="flexRow">
						<a
							class="lianjie_a_box"
							href="https://www.ndrc.gov.cn/?code=&state=123"
							target="_blank"
						>
							<img src="../../assets/link2/logo01.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.drc.gov.cn/default.aspx"
							target="_blank"
						>
							<img src="../../assets/link2/logo02.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.mee.gov.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo03.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.ncc-cma.net/cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo04.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://www.pbc.gov.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo05.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://www.mof.gov.cn/index.htm"
							target="_blank"
						>
							<img src="../../assets/link2/logo06.jpg" alt="" />
						</a>
					</div>
					<div class="flexRow">
						<a
							class="lianjie_a_box"
							href="https://www.ccer.com.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo07.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.ceads.net.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo08.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://meicmodel.org/?ref=*.co2.press"
							target="_blank"
						>
							<img src="../../assets/link2/logo09.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://www.prcee.org/?ref=*.co2.press"
							target="_blank"
						>
							<img src="../../assets/link2/logo10.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://www.caf.ac.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo11.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="http://www.china-epc.cn/"
							target="_blank"
						>
							<img src="../../assets/link2/logo12.jpg" alt="" />
						</a>
					</div>
					<div class="flexRow">
						<a
							class="lianjie_a_box"
							href="https://www.shihang.org/zh/home"
							target="_blank"
						>
							<img src="../../assets/link2/logo13.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.iea.org/"
							target="_blank"
						>
							<img src="../../assets/link2/logo14.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://www.ipcc.ch/"
							target="_blank"
						>
							<img src="../../assets/link2/logo15.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://cdm.unfccc.int/?ref=*.co2.press#"
							target="_blank"
						>
							<img src="../../assets/link2/logo16.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://ieep.eu/?ref=*.co2.press"
							target="_blank"
						>
							<img src="../../assets/link2/logo17.jpg" alt="" />
						</a>
						<a
							class="lianjie_a_box"
							href="https://icapcarbonaction.com/"
							target="_blank"
						>
							<img src="../../assets/link2/logo18.jpg" alt="" />
						</a>
					</div>
				</div>
			</div>
		</div>
		<div
			id="adl0"
			style="
				display: block;
				position: fixed;
				left: 33px;
				top: 430px;
				width: 120px;
				height: 270px;
				overflow: hidden;
				z-index: 1999;
			"
		>
			<a
				href="https://www.drcnet.com.cn/bayWindow/carbon"
				target="_blank"
			>
				<img src="../../assets/bayWindow/carbon.png" border="0"
			/></a>
			<div
				style="
					text-align: right;
					padding: 2px;
					font-size: 12px;
					cursor: pointer;
				"
				class="closeFloatl0"
			>
				关闭
			</div>
		</div>
		<Footer></Footer>
		<el-backtop target=".home"></el-backtop>
	</div>
</template>
<script>
import Header from '@/components/header';
import Footer from '@/components/footer';
import Shoufengqin from '@/components/shoufengqin';
import api from '@/../static/common/api/api.js';
import kLines from './components/kLines';
import doubleLins from './components/doubleLins';
import treemap from './components/treemap';
import wordcounts from './components/wordcounts';
import acrossBar from './components/acrossBar';
export default {
	name: '',
	components: {
		Header,
		Footer,
		Shoufengqin,
		kLines,
		doubleLins,
		treemap,
		wordcounts,
		acrossBar,
	},
	mixins: [],
	props: {},
	data() {
		return {
			scrollTop: 0, //页面吸顶条参数
			mrtj: [], //每日推荐
			rdzt: [], //热点专题
			thts: {}, //碳汇碳税
			tjr: {}, //碳金融
			zcfg: {}, //政策规划
			zcjd: {}, //政策解读
			qhst: {}, //气候生态
			tpf: {}, //碳排放
			tsc: {}, //碳市场
			tjr: {}, //碳金融
			zjpl: {}, //专家评论
			yjbg: {}, //研究报告
			yjbg_uid: 'A61831',
			dxal: {}, //典型案例
			zcfgandqydt: {}, //政策规划和前沿动态
			zjplandalsj: {}, //专家评论和案例实践
			syq: {}, //试验区
			acrossBarDatas: [], //四个横条图
			hybz: {}, //行业标准
			xxpl: {}, //信息披露
			hightTitle: '', //高层声音标题
			ou: {}, //欧洲
			us: {}, //美国
			countryList: [
				{ id: 1, name: '美国', type: 'country' },
				{ id: 1, name: '英国', type: 'country' },
				{ id: 1, name: '德国', type: 'country' },
				{ id: 1, name: '法国', type: 'country' },
				{ id: 1, name: '日本', type: 'country' },
				{ id: 1, name: '韩国', type: 'country' },
				{ id: 1, name: '澳大利亚', type: 'country' },
				{ id: 1, name: '其他', type: 'country' },
			],
			provinceList: [{ id: 1, name: '美国', type: 'province' }],
			marqueeList: [],
		};
	},
	computed: {},
	filters: {
		subData: function(value) {
			return value.substring(0, 10);
		},
	},
	watch: {},
	mounted() {
		this.closeFixed();
		this.getTopHightTitle('A601,A6020101'); //获取高层声音,中央正常
		this.fetchDataMRTJ('A60602'); //热点专题
		this.fetchDataHot(); //热点专题
		// this.fetchThts('411501'); // 碳汇碳税
		this.fetchZcjd('A6020103'); // 碳汇碳税

		this.fetchDataZCFG('A6020101', 1); //政策规划 默认：中央
		this.fetchDataTPF('A6063201', 1); //碳排放;默认低碳技术
		this.fetchDataQHST('A6062801', 1); //气候生态，默认气候治理
		this.fetchDataTSC('A60633', 1); //碳市场 默认：碳市场
		this.fetchDataTJR('A6063401', 1); //碳金融 默认：碳信贷
		this.fetchZJPL('A610'); // 专家评论
		this.fetchDataYJBG('A61831', 1); //研究报告 默认:报告
		this.fetchDataSTSJ('1', 1); //双碳实践 默认：北京
		this.fetchDXAL('A619'); //典型案例
		this.fetchZCFGAndQYDT('A621011708', 1); //政策法规和前沿动态
		this.fetchZJPLAndALSJ('A621011702', 1); //专家评论和案例实践
		this.fetchSYQ('A6210119'); //试验区
		this.fetchHYBZ('A6212901'); //行业标准
		this.fetchXXPL('A6212902'); //信息披露
		this.fetchSomeTransactionLineData(); //首页第一屏--获取美国，欧盟或者英国的碳排放交易折线图数据
		this.fetchProvince(); //获取省份
	},
	methods: {
		//吸顶条参数
		handleScroll() {
			this.scrollTop = document.getElementsByClassName(
				'home'
			)[0].scrollTop;
		},
		closeFixed() {
			//首页飘窗
			$('.closeFloatl0').click(function() {
				$('#adl0').hide();
			});
			$('.closeFloatl1').click(function() {
				$('#adl1').hide();
			});
			$('.closeFloatl3').click(function() {
				$('#adl3').hide();
			});
			$('.closeFloatl4').click(function() {
				$('#adl4').hide();
			});
			// $('.closeFloatr1').click(function () {
			// 	$('#adr1').hide();
			// });
		},
		//热点专题跳转
		toRdzt(item) {
			this.$router.push({
				path: '/hotdetail',
				query: { chnId: item.chnId },
			});
		},
		fetchSomeTransactionLineData() {
			api.getSomeTransactionLineData(1).then((res) => {
				this.ou = res;
			});
			api.getSomeTransactionLineData(2).then((res) => {
				this.us = res;
			});
		},
		//点击tab标签跳转到相应的页面
		clicktabfn(url, flag) {
			if (flag) {
				const routeData = this.$router.resolve({ path: url });
				window.open(routeData.href, '_blank');
			} else {
				this.$router.push({ path: url });
				// window.location.reload();
			}

			// window.location.reload();
		},
		fetchDataMRTJ(uid) {
			let param = { uid: uid, pagesize: 5, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.mrtj = res.data;
			});
		},
		//获取碳汇碳税数据
		fetchThts(uid) {
			let param = { uid: uid, pagesize: 5, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.thts = res.data;
			});
		},

		getTopHightTitle(uid) {
			let param = {
				uid: uid,
				pagesize: 10,
				curpage: 1,
				homepage: true,
			};
			api.getDocList(param).then((res) => {
				this.hightTitle = res.data.slice(0, 1)[0];
				this.marqueeList = res.data.slice(2, 10);
				// //console.log(this.marqueeList);
			});
		},
		//热点
		fetchDataHot() {
			let param = {
				chnid: 7392,
				topNumber: 100,
				pagesize: 2,
				curpage: 1,
			};
			api.getTopListByChnIdAndYear(param).then((res) => {
				// //console.log(res.data, 'res.data+_test');
				this.rdzt = res.data.dataList;
			});
		},
		fetchZcjd(uid) {
			let param = { uid: uid, pagesize: 6, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.zcjd = res.data;
			});
		},
		//获取政策规划
		fetchDataZCFG(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[name].style.color = '#55BE48';
			}
			let param = { uid: _uid, pagesize: 7, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.zcfg = res.data;
			});
		},
		fetchDataQHST(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[name].style.color = '#55BE48';
			}
			let param = { uid: _uid, pagesize: 6, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.qhst = res.data;
			});
		},
		//碳排放
		fetchDataTPF(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 3].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 4].style.color = '#1C1C1C';
				this.$refs[name].style.color = '#55BE48';
			}
			let param = { uid: _uid, pagesize: 6, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.tpf = res.data;
			});
		},
		//获取碳市场数据
		fetchDataTSC(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 3].style.color = '#1C1C1C';

				this.$refs[name].style.color = '#55BE48';
			}

			let param = { uid: _uid, pagesize: 6, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				this.tsc = res.data;
			});
		},
		//获取碳金融数据
		fetchDataTJR(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 3].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 4].style.color = '#1C1C1C';

				this.$refs[name].style.color = '#55BE48';
			}

			let param = { uid: _uid, pagesize: 6, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				// $('.article_l_tab1').removeClass('active');
				// $('.article_l_tab2').removeClass('active');
				// $('.article_l_tab' + i).addClass('active');
				this.tjr = res.data;
			});
		},
		//获取专家评论
		fetchZJPL(uid) {
			let param = { uid: uid, pagesize: 11, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.zjpl = res.data;
			});
		},

		//获取研究报告
		fetchDataYJBG(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 3].style.color = '#1C1C1C';

				this.$refs[name].style.color = '#55BE48';
			}

			let param = { uid: _uid, pagesize: 5, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里
			this.yjbg_uid = _uid;
			api.getDocList(param).then((res) => {
				this.yjbg = res.data;
			});
		},

		fetchDataSTSJ(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 3].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 4].style.color = '#1C1C1C';
				this.$refs[name].style.color = '#55BE48';
			}

			// let param = { uid: _uid, pagesize: 5, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getCarbonPracticeData(_uid).then((res) => {
				this.acrossBarDatas = res.data;
				//console.log(res);
			});
		},

		//获取典型案例
		fetchDXAL(uid) {
			let param = { uid: uid, pagesize: 9, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.dxal = res.data;
			});
		},
		//政策规划和前沿动态
		fetchZCFGAndQYDT(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C ';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C ';

				this.$refs[name].style.color = '#55BE48 ';
			}

			let param = { uid: _uid, pagesize: 4, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				this.zcfgandqydt = res.data;
			});
		},
		//专家评论和案例实践
		fetchZJPLAndALSJ(_uid, i = 0, name = '') {
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C ';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C ';

				this.$refs[name].style.color = '#55BE48 ';
			}

			let param = { uid: _uid, pagesize: 4, curpage: 1 };

			// param.uid = '7407';//等有数据了去掉这里

			api.getDocList(param).then((res) => {
				this.zjplandalsj = res.data;
			});
		}, //试验区
		fetchSYQ(uid) {
			let param = { uid: uid, pagesize: 4, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.syq = res.data;
			});
		},
		//行业标准
		fetchHYBZ(uid) {
			let param = { uid: uid, pagesize: 4, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.hybz = res.data;
			});
		}, //信息披露
		fetchXXPL(uid) {
			let param = { uid: uid, pagesize: 4, curpage: 1 };
			api.getDocList(param).then((res) => {
				this.xxpl = res.data;
			});
		},
		fetchProvince() {
			api.getDynamicInfoTagsList().then((res) => {
				if (res.data) {
					this.provinceList = res.data[1].tags;
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
.home {
	min-width: 1200px !important;
	// height: 100vh;
	height: 100%;
	overflow-x: hidden;
	.backImg {
		width: 100%;
		// height: 100%;
		background: url('../../assets/homeContent/contentBackground.png')
			no-repeat center;
		background-size: cover;
	}

	.contents {
		width: 1300px;
		margin: 0 auto;
		height: 100%;

		.content {
			min-height: 330px;
			width: 100%;
		}

		.list1 {
			display: flex;
			flex-direction: column;
			.shuangtan_img_info_item {
				width: 208px !important;
			}
			.block1_1 {
				text-align: center;
				font-family: Microsoft YaHei;
				font-weight: bold;
				font-size: 24px;
				color: #146e08;
				margin: 12px 0 26px 0;
				// white-space: nowrap;
				// overflow: hidden;
				a {
					color: #146e08;
					word-wrap: break-word;
					word-break: normal;
				}
			}
			.block1_2 {
				text-align: center;
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 15px;
				color: #666666;
				margin: 19px 0 12px 0;
				white-space: nowrap;
				overflow: hidden;
				display: flex;
				.lbTitle {
					display: inline-block;
					color: #1a1a1a;
				}
				.crilce {
					display: inline-block;
					width: 5px;
					height: 5px;
					border-radius: 50%;
					background: #666666;
					vertical-align: middle;
				}
				.marqueeTitle {
					color: #666666;
					margin-right: 18px;
				}
			}
			.block1_3 {
				padding-bottom: 50px;
				.cloumChunk {
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.rowChunk {
					}
					.details1_1 {
						width: 360px;
						height: 300px;
						margin-bottom: 45px;
					}
					.details1_2 {
						width: 360px;
						height: 300px;
					}
					// .details1_3_title {
					// 	width: 487px;
					// 	height: 20px;
					// 	margin-bottom: 20px;
					// }
					.details1_3 {
						width: 487px;
						height: 390px;
					}
					.details1_4 {
						width: 487px;
						height: 233px;
					}
					.details1_5 {
						width: 367px;
						height: 340px;
						margin-bottom: 0px;
					}
					.details1_6 {
						.littleTitle {
							padding-top: 4px;
						}
						width: 367px;
						height: 305px;
						// margin-top: 2px;
						position: relative;
						// .postionLinks {
						// 	position: absolute;
						// 	a {
						// 		width: 40px;
						// 		height: 40px;
						// 		display: block;
						// 	}
						// }
						// .links1 {
						// 	top: 31px;
						// 	left: 61px;
						// }
						// .links2 {
						// 	top: 93px;
						// 	left: 80px;
						// }
						// .links3 {
						// 	top: 136px;
						// 	left: 138px;
						// }
						// .links4 {
						// 	top: 136px;
						// 	left: 213px;
						// }
						// .links5 {
						// 	top: 93px;
						// 	left: 267px;
						// }
						// .links6 {
						// 	top: 31px;
						// 	left: 289px;
						// }
						// .links7 {
						// 	top: 4px;
						// 	left: 144px;
						// 	a {
						// 		width: 102px;
						// 		height: 102px;
						// 	}
						// }
					}
				}
			}
		}
		.list2 {
			.block2_1 {
				text-align: center;

				margin: 0px 0 5px 0;
			}

			.block2_4 {
				.block2_4_backgroud {
					text-align: left;
					margin: 0px 0 23px 0;
					width: 100%;
					height: 30px;
					border-bottom: 1px solid #b5b5b5;
				}
				.block2_4_title {
					width: 86px;
					position: relative;
					top: 2.5px;
					text-align: center;
					font-family: Source Han Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #1a1a1a !important;
					border-bottom: 3px solid rgba(85, 190, 72, 1);
				}
				.spanH5 {
					color: #1a1a1a !important;
				}
				// 行业动态
				.block2_4_report_under_box {
					width: 100%;
					overflow: hidden;
					margin-bottom: 70px;
					padding: 8px 5px 0 5px;
				}
				.block2_4_report_under_box a {
					display: inline-block;
					width: 173px;
					height: 71px;
					background: #ffffff;
					box-shadow: 0px 6px 18px 2px #eceeeb;
					border-radius: 2px;
					// margin-left: 14px;
					margin-bottom: 24px;
					border: 1px solid #fff;
					display: flex;
					flex-direction: row;
					align-items: center;
				}
				.block2_4_report_under_box a:hover {
					border: 1px solid #88c780;
				}
				.block2_4_report_under_box a img {
					width: 54px;
					display: block;
					margin: 0 12px;
					// margin: 33px auto 5px;
				}
				.block2_4_report_under_box a span {
					width: 100%;
					text-align: left;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #404040;
					display: block;
					word-break: break-all;
					// overflow: hidden;
					// white-space: nowrap;
					// text-overflow: ellipsis;
					// -o-text-overflow: ellipsis;
				}
			}
			.block2_3 {
				padding-bottom: 50px;
				.cloumChunk {
					.rowChunk {
						// background: #084f00;
					}
					.details2_1 {
						width: 400px;
						height: 335px;
						margin-right: 50px;
						margin-bottom: 47px;
					}
					.details2_2 {
						width: 400px;
						height: 335px;
						margin-right: 50px;
					}
					.details2_3 {
						width: 400px;
						height: 335px;
						margin-bottom: 47px;
					}
					.details2_4 {
						width: 400px;
						height: 335px;
					}
					.details2_5 {
						width: 401px;
						height: 207px;
						margin-bottom: 40px;
						.countryLists {
							margin-top: 10px;
							.countryBlocks {
								display: inline-block;
								min-width: 80px;
								padding: 0 5px;
								height: 32px;
								background: rgba(255, 255, 255, 0.5);
								text-align: center;
								line-height: 32px;
								border-radius: 17px;
								border: 1px solid #d8ded4;
								font-family: Microsoft YaHei;
								font-weight: 400;
								font-size: 15px;
								color: #333333;
								margin-right: 10px;
								margin-bottom: 9px;
								cursor: pointer;
							}
							.countryBlocks:nth-of-type(4n) {
								margin-right: 0;
							}
						}
					}
					.details2_6 {
						width: 401px;
						height: 478px;
						.countryLists {
							margin-top: 10px;
							.countryBlocks {
								display: inline-block;
								min-width: 80px;
								padding: 0 5px;
								height: 32px;
								background: rgba(255, 255, 255, 0.5);
								text-align: center;
								line-height: 32px;
								border-radius: 17px;
								border: 1px solid #d8ded4;
								font-family: Microsoft YaHei;
								font-weight: 400;
								font-size: 15px;
								color: #333333;
								margin-right: 10px;
								margin-bottom: 9px;
								cursor: pointer;
							}
							.countryBlocks:nth-of-type(4n) {
								margin-right: 0;
							}
						}
					}
				}
			}
		}
		.list3 {
			display: flex;
			flex-direction: column;
			.block3_1 {
				text-align: center;

				margin: 0px 0 23px 0;
			}
			.block3_2 {
				padding-bottom: 50px;
				.cloumChunk {
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.rowChunk {
						// background: #084f00;
					}
					.details3_1 {
						width: 399px;
						height: 543px;
					}
					.details3_3_title {
						width: 401px;
						height: 20px;
						margin-bottom: 20px;
					}
					.details3_3 {
						width: 401px;
						height: 263px;
						margin-bottom: 29px;
					}
					.details3_4 {
						text-align: center;
						width: 401px;
						height: 203px;
						position: relative;
						left: 10px;
						top: -8px;
						.postionLinks {
							position: absolute;
							a {
								width: 112px;
								height: 40px;
								display: block;
								font-size: 15px;
								font-weight: 600;
								font-family: Microsoft YaHei;
								color: rgb(64, 65, 66);
								text-align: left;
								line-height: 40px;
							}
							a:hover {
								color: rgb(75, 186, 62);
							}
						}
						.links1 {
							top: 40px;
							left: -4px;
						}
						.links2 {
							top: 102px;
							left: 16px;
						}
						.links3 {
							top: 144px;
							left: 89px;
							a {
								width: 95px;
							}
						}
						.links4 {
							top: 145px;
							left: 218px;
							a {
								width: 98px;
								text-align: right;
							}
						}
						.links5 {
							top: 102px;
							left: 273px;
							a {
								text-align: right;
							}
						}
						.links6 {
							top: 40px;
							left: 293px;
							a {
								width: 83px;
								text-align: right;
							}
						}
						.links7 {
							top: 12px;
							left: 151px;
							a {
								width: 102px;
								height: 102px;
								color: #fff;
								text-align: center;
								line-height: 144px;
							}
							a:hover {
								color: rgb(175, 216, 96);
							}
						}
					}
					.details3_5 {
						width: 399px;
						height: 543px;
						.article_l_list {
							.reportList {
								height: 89px;
								white-space: normal;
							}
							.reportImg {
								width: 108px;
								height: 90px;
								min-width: 108px;
								min-height: 90px;
							}
							.reportSpanBlock {
								// width: 268px !important;
								overflow: hidden;
								padding: 8px 11px 8px 8px;
								.reportspan1 {
									// display: block;
									// white-space: normal;
									// word-break: break-all;
									font-size: 15px;
									font-family: Source Han Sans CN;
									font-weight: 500;
									color: rgba(26, 26, 26, 1);
									margin-bottom: 10px;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									/*! autoprefixer: off */
									-webkit-box-orient: vertical;
									/* autoprefixer: on */
									-webkit-line-clamp: 2;
								}
								.reportspan2 {
									width: 100% !important;
									text-align: left;
									display: block;
									font-size: 14px;
									color: #868686;
								}
							}
						}
					}
				}
			}
		}
		.list4 {
			.block4_1 {
				text-align: center;

				margin: 0px 0 23px 0;
			}
			.block4_3 {
				padding-bottom: 50px;
				.cloumChunk {
					.rowChunk {
						// background: #084f00;
					}
					.details4_1 {
						width: 416px;
						height: 195px;
						margin-right: 19px;
						margin-bottom: 16px;
						background: rgba(255, 255, 255, 0);
						border: 1px solid #d2d2d2;
					}
					.details4_2 {
						width: 416px;
						height: 195px;
						margin-right: 19px;
						background: rgba(255, 255, 255, 0);
						border: 1px solid #d2d2d2;
					}
					.details4_3 {
						width: 416px;
						height: 195px;
						margin-bottom: 16px;
						background: rgba(255, 255, 255, 0);
						border: 1px solid #d2d2d2;
					}
					.details4_4 {
						width: 416px;
						height: 195px;
						background: rgba(255, 255, 255, 0);
						border: 1px solid #d2d2d2;
					}
					.details4_5 {
						width: 399px;
						height: 474px;
						.article_l_list {
							a {
								margin-top: 12px;
							}
						}
						// margin-bottom: 40px;
					}
				}
			}
		}
		.list5 {
			.block5_3 {
				padding-bottom: 50px;
				.cloumChunk {
					.rowChunk {
						// background: #084f00;
					}
					.littleTitle {
						.spanA {
							margin: 0 5px;
							font-size: 16px !important;
						}
					}
					.fetchDatashu {
						margin: 0;
					}
					.details5_1 {
						width: 400px;
						height: 251px;
						margin-right: 49px;
						margin-bottom: 40px;
					}
					.details5_2 {
						width: 400px;
						height: 251px;
						margin-right: 49px;
					}
					.details5_3 {
						width: 400px;
						height: 251px;
						margin-bottom: 40px;
					}
					.details5_4 {
						width: 400px;
						height: 251px;
						.lvjin_a_box {
							width: 100%;
							// margin-top: 30px;
						}
						.lvjin_a_box a {
							display: inline-block;
							width: 188px;
							height: 94px;
							background: linear-gradient(
								0deg,
								#fafafa,
								#fafafa,
								#ffffff
							);
							border: 1px solid #ececec;
							margin-bottom: 21px;
						}
						.lvjin_a_box a:hover {
							border: 1px solid #4eac41;
							background: #fafafa;
							box-shadow: 0px 3px 7px 0px rgba(118, 179, 43, 0.35);
						}
						.lvjin_a_box a:nth-child(1) {
							margin-right: 16px;
						}
						.lvjin_a_box a:nth-child(3) {
							margin-right: 16px;
						}
						.lvjin_a_box a:nth-child(5) {
							margin-right: 20px;
						}
						.lvjin_a_box a img {
							width: 27px;
							display: block;
							margin: 20px auto 8px;
						}
						.lvjin_a_box a span {
							display: block;
							width: 100%;
							text-align: center;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: bold;
							color: #333333;
						}
					}
					.details5_5 {
						width: 400px;
						height: 251px;
						margin-bottom: 40px;
					}
					.details5_6 {
						width: 400px;
						height: 251px;
						// margin-bottom: 40px;
					}
				}
			}
		}
		.list6 {
			// 相关链接
			.lianjie_main_title {
				width: 100%;
				display: block;
				margin: 60px auto 45px;
			}
			.lianjie_a_box {
				width: 191px;
				height: 57px;
				background: #ffffff;
				border: 1px solid #f7f7f7;
				box-shadow: 0px 14px 20px 0px #f2f5f1;
				display: inline-block;
				overflow: hidden;
				// margin-right: 28px;
				margin-bottom: 14px;
				border: 1px solid #fff;
			}
			.lianjie_a_box:hover {
				border: 1px solid #88c780;
				box-shadow: 0px 14px 20px 0px #f2f5f1;
			}
			.lianjie_a_box img {
				width: 100%;
				display: block;
			}
		}
	}
	.asticle_l_title_item {
		font-family: Source Han Sans CN;
		font-weight: 600;
		font-size: 18px;
		color: #1a1a1a;
		align-items: center;
		img {
			width: 3px;
			height: 18px;
			vertical-align: middle;
		}
		.spanH5 {
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			color: #1a1a1a;
			margin: 0 11px 0 5px;
		}
		.spanA {
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 11px 0 5px;
		}
		.spanC {
			color: #1a1a1a;
			font-size: 16px !important;
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 5px 0 5px;
		}
		span {
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 11px 0 5px;
		}
		i {
			font-style: normal;
			width: 100%;
			height: 10px;

			display: inline-block;
			background: url('../../assets/homeContent/title_sp.jpg') repeat-x
				center;
		}
		.article_l_more {
			display: inline-block;
			cursor: pointer;
			font-size: 12px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #1a1a1a;
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 0 0 8px;
			img {
				margin-left: 6px;
				margin-right: 3px;
				width: 9px;
				height: 9px;
			}
		}
	}
	.littleTitle {
		.spanA {
			font-family: Source Han Sans CN;
			font-weight: 600;
			font-size: 18px !important;
			color: #1a1a1a !important;
		}
	}
	//公共样式
	.block2_3_backgroud {
		display: flex;
		justify-content: space-between;
		text-align: left;
		margin: 0px 0 23px 0;
		width: 100%;
		height: 30px;
		border-bottom: 1px solid #b5b5b5;
	}
	.block2_3_title {
		width: 86px;
		position: relative;
		top: 2.5px;
		text-align: center;
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 17px;
		color: #1a1a1a;
		border-bottom: 3px solid rgba(85, 190, 72, 1);
		.spanA {
			font-family: Source Han Sans CN;
			font-weight: 500;
			font-size: 16px !important;
			color: #1a1a1a !important;
		}
	}

	.shuangtan_l_tab_smbox {
		line-height: 30px;
		padding-right: 8px;
		display: flex;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 0 0 8px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: rgba(28, 28, 28, 1);
		.fetchDatashu {
			margin: 0 6px;
			vertical-align: sub;
			color: rgba(114, 114, 114, 1);
		}
		a {
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: rgba(28, 28, 28, 1);
		}
	}
	.rowChunk {
		// background: #084f00;
		.article_l_more {
			display: inline-block;
			cursor: pointer;
			font-size: 12px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #1a1a1a;
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 0 0 8px;
			img {
				margin-left: 6px;
				margin-right: 3px;
				width: 9px;
				height: 9px;
			}
		}
		.shuangtan_img_info_box {
			width: 100%;
			height: 100px;
			overflow: hidden;
			display: flex;
			margin-top: 22px;
			cursor: pointer;
			img {
				width: 124px;
				height: 99px;
				display: block;
				float: left;
			}
		}
		.shuangtan_img_info_item {
			width: 244px;
			height: 68px;
			// background: #fafafa;
			float: right;
			padding: 17px 8px 17px 22px;
			cursor: pointer;
			h5 {
				font-size: 15px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #333333;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}
			p {
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #666666;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				margin-top: 6px;
			}
		}
		.shuangtan_l_tab_smbox {
			display: flex;
			overflow: hidden;
			white-space: nowrap;
			min-width: min-content;
			margin: 0 0 0 8px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: rgba(28, 28, 28, 1);
			.fetchDatashu {
				margin: 0 6px;
				vertical-align: sub;
				color: rgba(114, 114, 114, 1);
			}
			a {
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: rgba(28, 28, 28, 1);
			}
		}
		.article_l_list {
			width: 100%;
			overflow: hidden;
			a {
				font-size: 15px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #666666;
				display: block;
				margin-top: 10px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}
			.span1 {
				width: 70%;
				display: inline-block;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}
			.span2 {
				width: 28%;
				display: inline-block;
				text-align: right;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}
		}
	}

	.flexRow {
		display: flex !important;
		flex-direction: row;
		justify-content: space-between;
	}
	.flexClounm {
		display: flex !important;
		flex-direction: column;
		justify-content: space-between;
	}
	.flexUnset {
		justify-content: unset !important;
	}
}
</style>
<style lang="less">
.asticle_l_title_item {
	font-family: Source Han Sans CN;
	font-weight: 600;
	font-size: 18px;
	color: #1a1a1a;
	align-items: center;
	img {
		width: 3px;
		height: 18px;
		vertical-align: middle;
	}
	.spanA {
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 11px 0 5px;
	}
	span {
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 11px 0 5px;
	}
	i {
		font-style: normal;
		width: 100%;
		height: 10px;

		display: inline-block;
		background: url('../../assets/homeContent/title_sp.jpg') repeat-x center;
	}
}
.littleTitle {
	.spanA {
		font-family: Source Han Sans CN;
		font-weight: 600;
		font-size: 16px !important;
		color: #1a1a1a !important;
	}
}
//公共样式
.block2_3_backgroud {
	display: flex;
	justify-content: space-between;
	text-align: left;
	margin: 0px 0 23px 0;
	width: 100%;
	height: 30px;
	border-bottom: 1px solid #b5b5b5;
}
.block2_3_title {
	width: 86px;
	position: relative;
	top: 2.5px;
	text-align: center;
	font-family: Source Han Sans CN;
	font-weight: 500;
	font-size: 17px;
	color: #1a1a1a;
	border-bottom: 3px solid rgba(85, 190, 72, 1);
	.spanA {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 16px !important;
		color: #1a1a1a !important;
	}
}

.shuangtan_l_tab_smbox {
	line-height: 30px;
	padding-right: 8px;
	display: flex;
	overflow: hidden;
	white-space: nowrap;
	min-width: min-content;
	margin: 0 0 0 8px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: rgba(28, 28, 28, 1);
	.fetchDatashu {
		margin: 0 6px;
		vertical-align: sub;
		color: rgba(114, 114, 114, 1);
	}
	a {
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: rgba(28, 28, 28, 1);
	}
}
.rowChunk {
	// background: #084f00;
	.article_l_more {
		display: inline-block;
		cursor: pointer;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 300;
		color: #1a1a1a;
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 3px 0 0 8px;
		img {
			margin-left: 6px;
			margin-right: 3px;
			width: 9px;
			height: 9px;
		}
	}
	.shuangtan_img_info_box {
		width: 100%;
		height: 100px;
		overflow: hidden;
		display: flex;
		margin-top: 22px;
		cursor: pointer;
		img {
			width: 124px;
			height: 99px;
			display: block;
			float: left;
		}
	}
	.shuangtan_img_info_item {
		width: 244px;
		height: 68px;
		// background: #fafafa;
		float: right;
		padding: 17px 8px 17px 22px;
		cursor: pointer;
		h5 {
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #333333;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
		p {
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #666666;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			margin-top: 6px;
		}
	}
	.shuangtan_l_tab_smbox {
		display: flex;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 0 0 8px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: rgba(28, 28, 28, 1);
		.fetchDatashu {
			margin: 0 6px;
			vertical-align: sub;
			color: rgba(114, 114, 114, 1);
		}
		a {
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: rgba(28, 28, 28, 1);
		}
	}
	.article_l_list {
		width: 100%;
		overflow: hidden;
		a {
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #666666;
			display: block;
			margin-top: 10px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
		.span1 {
			width: 70%;
			display: inline-block;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
		.span2 {
			width: 28%;
			display: inline-block;
			text-align: right;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}
}

.flexRow {
	display: flex !important;
	flex-direction: row;
	justify-content: space-between;
}
.flexClounm {
	display: flex !important;
	flex-direction: column;
	justify-content: space-between;
}
.flexUnset {
	justify-content: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue